import { Button, ButtonGroup, Dropdown, Field } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { actions } from 'Data/ReduxViewModels/Ags/Project';
import { ListItemModel } from 'Data/ViewModels/ListItemModel';
import { Guid } from 'Lib/Guid';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const ReIssueSection: React.FC = () => {
  const dispatch = useDispatch();

  const dateRangeOptions: ListItemModel[] = useSelector(
    (state) => state.agsProjectExport.historyDateRangeSelectList ?? []
  );

  const busyState = useSelector((state) => state.agsProjectExport.status?.busyState);
  const processing = useSelector((state) => state.agsProjectExport.pageHeader?.processing);

  const [reIssueDateRangeValue, setReIssueDateRangeValue] = useState<Guid>();

  const reissueButtonDisabled: boolean = !reIssueDateRangeValue || processing;

  return (
    <ListFieldSection>
      <Field
        input={<Dropdown />}
        label="Date Range"
        name="dateRange"
        options={dateRangeOptions}
        onChange={(event: any) => setReIssueDateRangeValue(event.data.value)}
        simpleValue
      />
      <div className="AgsProjectExportPage-ReissueButton">
        <ButtonGroup>
          <Button
            onClick={() => dispatch(actions.reissueExport(reIssueDateRangeValue))}
            disabled={reissueButtonDisabled}
            loading={busyState}
          >
            Re-issue
          </Button>
        </ButtonGroup>
      </div>
    </ListFieldSection>
  );
};

export default ReIssueSection;
